import React from 'react';
import Item from './Item';
export default class List extends React.Component {
	constructor (props) {
		super(props);

		this.select = this.select.bind(this);
	}
	select (e) {
		this.props.selected(this.props.course);
	}
	render () {
		const { course, selectedId } = this.props;

		return (
			<button role="tab" aria-selected={selectedId === course.id ? 'true' : 'false'} aria-controls={`course-tile-${course.id}`} onClick={this.select} key={'simple-list-' + course.id} className={`attractions-listitem ${selectedId === course.id ? 'active' : ''}`}>
				{course.title}
			</button>
		);
	}
}
